module.exports = __webpack_public_path__ + "static/www/img/dream@3x.07d6a2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bannerInfo/dream@3x.png
// module id = 367
// module chunks = 1